<template>
  <div @click="goTo('Menu')" class="home">
    <div
      class="background"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/mayologobg2.png') + ')'
      }"
    ></div>
    <div class="container">
      <img src="@/assets/img/mayologo.png" />
      <h1>Welcome to the Additive Manufacturing Facility</h1>
      <div class="touch">
        <img src="@/assets/img/touch_white.png" />
        <p>Touch to start</p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "home",
  components: {},
  data() {
    return {};
  },
  firestore() {
    return {
      data: db.collection("data")
    };
  },
  mounted() {},
  created() {},
  updated() {},
  methods: {}
};
</script>

<style scoped>
.btn.back {
  display: none !important;
}
</style>
